import { Card } from '@design/components/card/Card';
import { NoDataFound } from '@terminal/components/no-data-found/NoDataFound';

import styles from './EarningsReportingSummary.module.scss';

export interface ReportingSummaryEmptyStateProps {
  title: string;
  message: string;
  dataTestId: string;
}

export const ReportingSummaryEmptyState = ({
  title,
  message,
  dataTestId,
}: ReportingSummaryEmptyStateProps) => (
  <Card size="large" className={styles.emptyCard} data-testid={dataTestId}>
    <p className={styles.title}>{title}</p>
    <NoDataFound
      bannerPath="/app/static/images/empty-state/radio-telescope.png"
      size="small"
      title={message}
    />
  </Card>
);
